import { KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Colors } from '../../../ui/theme/colors';

export const deliveryStateToColor: Record<KnownDeliveryState, string> = {
  'in-progress': Colors.bookedScannedInProgressGray,
  overdue: Colors.overdueOrange,
  delivered: Colors.deliveredBlue,
  'delivered-offline': Colors.bookedScannedInProgressGray,
  collected: Colors.collectedGreen,
  cancelled: Colors.cancelledDeletedRed,
  retrieved: Colors.retrievedPurple,
  'retrieval-required': Colors.retrievalRequiredPurple,
  abandoned: Colors.cancelledDeletedRed
};
